import React, { FC } from 'react';
import { CSSTransition } from 'react-transition-group';
import { CandidateProfile } from './CandidateProfile';
import { CandidateProfileWithAnimationProps } from './props';

export const CandidateProfileWithAnimation: FC<CandidateProfileWithAnimationProps> = ({
  isOpen,
  isApplicationLoading,
  ...restProps
}) => {
  return (
    <CSSTransition appear classNames="candidate-profile" in={isOpen} mountOnEnter timeout={300} unmountOnExit>
      <div className="candidate-profile">
        {isApplicationLoading}

        {isOpen && !isApplicationLoading ? <CandidateProfile {...restProps} /> : null}
      </div>
    </CSSTransition>
  );
};
